"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useIsMounted", {
    enumerable: true,
    get: ()=>_useIsMounted.useIsMounted
});
const _useIsMounted = require("./useIsMounted");
